/* Inventory of local data that should be migrated to the user account on first login. */
import { getAllFavorites } from "./dailyJourney";
import { getReadingProgress } from "./readingProgress";
import { collectLocalEntries } from "./journal";

const PLAN_PROGRESS_KEY = "cm_plan_progress_v1";

export function inventoryLocalData() {
  const favorites = getAllFavorites();
  const planProgress = readPlanProgress();
  const journal = collectLocalEntries();
  const total =
    (favorites.passages?.length || 0) +
    (favorites.devotionals?.length || 0) +
    (favorites.prayers?.length || 0) +
    Object.keys(planProgress || {}).length +
    (journal?.length || 0);
  return {
    total,
    favorites_passages: favorites.passages || [],
    favorites_devotionals: favorites.devotionals || [],
    favorites_prayers: favorites.prayers || [],
    plan_progress: planProgress || {},
    journal_entries: journal || [],
    has_continue_reading: !!getReadingProgress(),
  };
}

function readPlanProgress() {
  try {
    const raw = localStorage.getItem(PLAN_PROGRESS_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

const SYNC_FLAG_KEY = "cm_local_sync_done_v1";

export function isSyncAlreadyDone(userId) {
  try {
    const raw = localStorage.getItem(SYNC_FLAG_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed?.user_ids) && parsed.user_ids.includes(userId);
  } catch {
    return false;
  }
}

export function markSyncDone(userId) {
  try {
    const raw = localStorage.getItem(SYNC_FLAG_KEY);
    const parsed = raw ? JSON.parse(raw) : { user_ids: [] };
    if (!parsed.user_ids.includes(userId)) parsed.user_ids.push(userId);
    localStorage.setItem(SYNC_FLAG_KEY, JSON.stringify(parsed));
  } catch {}
}
